import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Spinner from './Spinner';

const EditorRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <Spinner />;
    }

    // Kullanıcı giriş yapmamışsa VEYA rolü 'user' ise giriş sayfasına yönlendir.
    if (!user || user.role === 'user') {
        return <Navigate to="/login" />;
    }

    // Rolü 'editor' veya 'admin' ise sayfayı göster.
    return children;
};

export default EditorRoute;